import { Component, OnDestroy, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { Language } from 'app/model/constant';
import { Currency } from 'app/model/currency.model';
import { Option } from 'app/model/dropdown/dropdown-option-model';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { CurrencyService } from 'app/services/currency/currency.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'act-dialog-switch-lang-currency',
  templateUrl: './dialog-switch-lang-currency.component.html',
  styleUrls: ['./dialog-switch-lang-currency.component.scss']
})
export class DialogSwitchLangCurrencyComponent implements OnInit, OnDestroy {
  public elementIdPage = 'dialog-switch-language-currency';
  public LANGUAGE = Language;
  public languageList: Option[] = [];
  public currentLanguage: string;
  public tempLanguage: string;
  public currencyList: Observable<Currency[]>;
  public tempCurrency: string;

  constructor(
    private dialogRef: MdDialogRef<DialogSwitchLangCurrencyComponent>,
    private appConfigService: AppConfigService,
    private currencyService: CurrencyService,
  ) { }

  ngOnInit() {
    this.languageList = this.appConfigService.getLanguageList();
    this.currentLanguage = this.appConfigService.getLanguage();
    this.tempLanguage = this.currentLanguage;
    this.currencyList = this.currencyService.getCurrencyList();
    this.tempCurrency = this.currencyService.getCurrencyCode();
  }

  ngOnDestroy() {
  }

  handleChangeLanguage(use: string) {
    this.tempLanguage = use;
  }

  handleChangeCurrency(use: string) {
    this.tempCurrency = use;
  }

  handleCancel() {
    this.dialogRef.close();
  }

  handleSubmit() {
    this.dialogRef.close({
      language: this.tempLanguage,
      currency: this.tempCurrency
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/menu-bar/dialog-switch-lang-currency/dialog-switch-lang-currency.component.ts